module.exports = __webpack_public_path__ + "img/squarelogo.4215f28c.png";